/**
 * Values are persisted as `km_story_reports.reason` (plain text).
 * Keep labels identical to values so moderators see stable copy in the dashboard.
 */
export const STORY_REPORT_REASONS = [
  { value: 'Harassment or hate', label: 'Harassment or hate' },
  { value: 'Spam or misleading', label: 'Spam or misleading' },
  { value: 'Explicit or harmful content', label: 'Explicit or harmful content' },
  { value: 'Privacy concern', label: 'Privacy concern' },
  { value: 'Copyright or plagiarism', label: 'Copyright or plagiarism' },
  { value: 'Other', label: 'Other (describe below)' },
];

export const DEFAULT_STORY_REPORT_REASON = STORY_REPORT_REASONS[0].value;
